/** «осталось 42 мин», «осталось 1 ч 05 мин», «меньше минуты». */
export function formatSupportTimeLeft(expiresAt: string, now: number): string {
    const minutes = Math.ceil((Date.parse(expiresAt) - now) / 60000);
    if (!Number.isFinite(minutes) || minutes <= 0) return 'срок истёк';
    if (minutes <= 1) return 'осталось меньше минуты';
    if (minutes < 60) return `осталось ${minutes} мин`;
    return `осталось ${Math.floor(minutes / 60)} ч ${String(minutes % 60).padStart(2, '0')} мин`;
}
